module.exports = __webpack_public_path__ + "img/CENTRAL_GERMANY.8fc7c608.jpg";